export const getTicketTypeLabel = (ticket) => {
  if (ticket.ticketType === 2) {
    return `기간권 · ${ticket.seatType === 1 ? '고정석' : '자유석'}`;
  }
  if (ticket.ticketType === 3) return '시간정액권';
  if (ticket.ticketType === 4) return '세미나실';
  return '-';
};

export const getSeatTicketCompatibility = (seat, ticket) => {
  if (Number(ticket.level) < Number(seat.level)) {
    return { available: false, label: `${seat.level}등급 좌석 이용 불가` };
  }

  if (ticket.ticketType === 2 && Number(ticket.seatType) !== Number(seat.seatType)) {
    return {
      available: false,
      label: `${seat.seatType === 1 ? '고정석' : '자유석'} 이용권 필요`,
    };
  }

  return { available: true, label: '사용 가능' };
};

export const isExitedFixedSeat = (seat) =>
  Number(seat.seatType) === 1 && Number(seat.isUsing) !== 1;
